(function () {
  var MIDDLEWARE = "https://blue-by-bunzl.m-vallee.workers.dev";
  var timers = new WeakMap();
  var lists = new WeakMap();

  function blockOf(el) { return el && el.closest ? el.closest('.cs-block') : null; }
  function inBlock(block, sel) { return block ? block.querySelector(sel) : null; }
  function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }

  function setCheckoutLock(locked) {
    var btns = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (locked) { b.setAttribute('disabled', 'disabled'); b.style.opacity = .5; b.style.pointerEvents = 'none'; }
      else { b.removeAttribute('disabled'); b.style.opacity = 1; b.style.pointerEvents = 'auto'; }
    }
  }

  function paintBlock(block, attrs) {
    var input = inBlock(block, '.cs-input');
    var results = inBlock(block, '.cs-results');
    var selected = inBlock(block, '.cs-selected');
    var manual = inBlock(block, '.cs-manual-form');
    if (results) results.innerHTML = '';
    if (manual) manual.style.display = 'none';
    if (attrs && attrs.SIREN) {
      if (input) input.style.display = 'none';
      if (selected) {
        var siren = attrs.SIREN || '';
        var routageVal = attrs["Code routage"] || siren;
        selected.innerHTML =
          '✓ <strong>' + (attrs["Raison sociale"] || 'Entreprise') + '</strong><br>' +
          '<span style="color:#065f46">SIRET ' + (attrs.SIRET || '') + '</span> · <a class="cs-edit">Modifier</a>' +
          '<div class="cs-routage-wrap">' +
            '<label class="cs-routage-lbl">Code routage (par défaut votre SIREN)</label>' +
            '<input class="cs-routage-live" type="text" data-siren="' + escAttr(siren) + '" value="' + escAttr(routageVal) + '">' +
          '</div>';
        selected.style.display = 'block';
      }
    } else {
      if (input) input.style.display = 'block';
      if (selected) selected.style.display = 'none';
    }
  }

  function applyCart(cart) {
    var attrs = (cart && cart.attributes) || {};
    var blocks = document.querySelectorAll('.cs-block');
    for (var i = 0; i < blocks.length; i++) { blocks[i].dataset.csReady = '1'; paintBlock(blocks[i], attrs); }
    setCheckoutLock(!attrs.SIREN);
  }

  function initPending(cart) {
    var attrs = (cart && cart.attributes) || {};
    var pending = document.querySelectorAll('.cs-block:not([data-cs-ready])');
    for (var i = 0; i < pending.length; i++) { pending[i].dataset.csReady = '1'; paintBlock(pending[i], attrs); }
    setCheckoutLock(!attrs.SIREN);
  }

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function saveAttributes(attrs) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }) }).then(function (r) { return r.json(); });
  }

  function search(block, term) {
    var results = inBlock(block, '.cs-results');
    if (results) results.innerHTML = '<div class="cs-empty">Recherche…</div>';
    fetch(MIDDLEWARE + '/company/search?q=' + encodeURIComponent(term))
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
      .then(function (items) {
        lists.set(block, items || []);
        if (!results) return;
        if (!items || !items.length) {
          results.innerHTML = '<div class="cs-empty">Aucune entreprise trouvée.<br><a class="cs-manual">Vous ne trouvez pas votre entreprise ?</a></div>';
          return;
        }
        results.innerHTML = items.map(function (c, idx) {
          return '<div class="cs-row" data-i="' + idx + '"><strong>' + c.name + '</strong><br>'
            + '<span style="color:#6B7280">' + c.siret + ' · ' + (c.ville || '') + '</span>'
            + '<span class="cs-pill ' + (c.active ? 'ok' : 'ko') + '">' + (c.active ? 'Actif' : 'Fermé') + '</span></div>';
        }).join('');
      })
      .catch(function () {
        if (results) results.innerHTML = '<div class="cs-empty">Recherche momentanément indisponible, réessayez.<br><a class="cs-manual">Saisir manuellement</a></div>';
      });
  }

  function select(block, c) {
    if (!c) return;
    if (!c.active) { alert('Établissement fermé — choisissez un établissement actif.'); return; }
    saveAttributes({
      "Raison sociale": c.name, "SIREN": c.siren, "SIRET": c.siret,
      "TVA intracom": c.tva, "Code APE": c.naf, "Adresse entreprise": c.adresse, "Code routage": c.siren
    }).then(applyCart);
  }

  function reset() {
    saveAttributes({ "Raison sociale": "", "SIREN": "", "SIRET": "", "TVA intracom": "", "Code APE": "", "Adresse entreprise": "", "Code routage": "" }).then(applyCart);
  }

  function openManual(block) {
    var input = inBlock(block, '.cs-input'), results = inBlock(block, '.cs-results'), manual = inBlock(block, '.cs-manual-form');
    if (results) results.innerHTML = '';
    if (input) input.style.display = 'none';
    if (manual) manual.style.display = 'block';
  }
  function closeManual(block) {
    var input = inBlock(block, '.cs-input'), manual = inBlock(block, '.cs-manual-form');
    if (manual) manual.style.display = 'none';
    if (input) { input.style.display = 'block'; input.focus(); }
  }

  function tvaKey(siren) {
    return String((12 + 3 * (Number(siren) % 97)) % 97).padStart(2, '0');
  }

  function isValidSiret(siret) {
    if (!/^\d{14}$/.test(siret)) return false;
    if (siret.indexOf('356000000') === 0) {
      var s = 0;
      for (var k = 0; k < 14; k++) s += parseInt(siret.charAt(k), 10);
      return s % 5 === 0;
    }
    var sum = 0;
    for (var i = 0; i < 14; i++) {
      var d = parseInt(siret.charAt(i), 10);
      if (i % 2 === 0) { d *= 2; if (d > 9) d -= 9; }
      sum += d;
    }
    return sum % 10 === 0;
  }

  function isValidTvaFr(tva, sirenFromSiret) {
    var v = (tva || '').replace(/\s/g, '').toUpperCase();
    var m = v.match(/^FR([0-9A-Z]{2})(\d{9})$/);
    if (!m) return false;
    var key = m[1], siren = m[2];
    if (sirenFromSiret && siren !== sirenFromSiret) return false;
    if (/^\d{2}$/.test(key)) {
      var expected = (12 + 3 * (Number(siren) % 97)) % 97;
      if (Number(key) !== expected) return false;
    }
    return true;
  }

  // pré-remplit TVA (calculée) + code routage (par défaut = SIREN) à partir du SIRET
  function autofillFromSiret(block) {
    var siretField = inBlock(block, '.cs-m-siret');
    var tvaField = inBlock(block, '.cs-m-tva');
    var routageField = inBlock(block, '.cs-m-routage');
    if (!siretField) return;
    var raw = (siretField.value || '').replace(/\s/g, '');
    var has9 = /^\d{9}/.test(raw);
    var siren = has9 ? raw.slice(0, 9) : '';
    if (tvaField) tvaField.value = has9 ? ('FR' + tvaKey(siren) + siren) : '';
    if (routageField && routageField.dataset.touched !== '1') {
      routageField.value = siren;
    }
  }

  function validateManual(block) {
    var siret = (inBlock(block, '.cs-m-siret').value || '').replace(/\s/g, '');
    var tva = (inBlock(block, '.cs-m-tva').value || '').trim();
    var routage = (inBlock(block, '.cs-m-routage').value || '').trim();
    var err = inBlock(block, '.cs-m-err');
    if (!isValidSiret(siret)) { err.textContent = 'SIRET invalide : vérifiez les 14 chiffres.'; err.style.display = 'block'; return; }
    if (!isValidTvaFr(tva, siret.slice(0, 9))) { err.textContent = 'TVA intracommunautaire invalide ou incohérente avec le SIRET.'; err.style.display = 'block'; return; }
    err.style.display = 'none';
    var siren = siret.slice(0, 9);
    if (!routage) routage = siren;
    saveAttributes({
      "Raison sociale": "Saisie manuelle", "SIREN": siren, "SIRET": siret,
      "TVA intracom": tva.replace(/\s/g, '').toUpperCase(), "Code APE": "", "Adresse entreprise": "", "Code routage": routage
    }).then(applyCart);
  }

  // saisie / recherche
  document.addEventListener('input', function (e) {
    if (!e.target.classList) return;
    if (e.target.classList.contains('cs-m-siret')) {
      autofillFromSiret(blockOf(e.target));
      return;
    }
    if (e.target.classList.contains('cs-m-routage')) {
      e.target.dataset.touched = '1';
      return;
    }
    if (!e.target.classList.contains('cs-input')) return;
    var block = blockOf(e.target);
    var term = e.target.value.trim();
    var t = timers.get(block); if (t) clearTimeout(t);
    var results = inBlock(block, '.cs-results');
    if (term.length < 2) { if (results) results.innerHTML = ''; return; }
    timers.set(block, setTimeout(function () { search(block, term); }, 350));
  });

  // modification du code routage dans la carte de confirmation (les deux chemins)
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('cs-routage-live')) return;
    var val = (e.target.value || '').trim();
    if (!val) val = e.target.dataset.siren || '';
    saveAttributes({ "Code routage": val }).then(applyCart);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var block = blockOf(t);
    var row = t.closest ? t.closest('.cs-row') : null;
    if (row && block) { select(block, (lists.get(block) || [])[+row.dataset.i]); return; }
    if (t.classList && t.classList.contains('cs-edit')) { e.preventDefault(); reset(); return; }
    if (t.classList && t.classList.contains('cs-manual')) { e.preventDefault(); openManual(block); return; }
    if (t.classList && t.classList.contains('cs-m-back')) { e.preventDefault(); closeManual(block); return; }
    if (t.classList && t.classList.contains('cs-m-validate')) { e.preventDefault(); validateManual(block); return; }
  });

  function scan() {
    if (!document.querySelector('.cs-block:not([data-cs-ready])')) return;
    fetchCart().then(initPending);
  }
  var deb;
  new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(scan, 150); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scan);
  scan();
})();